import { render, staticRenderFns } from "./LevelVarLink.vue?vue&type=template&id=e2ffa6e6&"
import script from "./LevelVarLink.vue?vue&type=script&lang=js&"
export * from "./LevelVarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports